import { render, staticRenderFns } from "./AdminBrand.vue?vue&type=template&id=cfbe5da0&scoped=true&"
import script from "./AdminBrand.vue?vue&type=script&lang=js&"
export * from "./AdminBrand.vue?vue&type=script&lang=js&"
import style0 from "./AdminBrand.vue?vue&type=style&index=0&id=cfbe5da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbe5da0",
  null
  
)

component.options.__file = "AdminBrand.vue"
export default component.exports